export const products = [
    {
        id: 1,
        name : "BISMARCK",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-1a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 1,
        price : 30
    },
    {
        id: 2,
        name : "FIORI DI ZUCCA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-2a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 2,
        price : 50
    },
    {
        id: 3,
        name : "VALDOSTANA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-3a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 2,
        price : 55
    },
    {
        id: 4,
        name : "PIZZA TARTUFATA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-4a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 3,
        price : 45
    },
    {
        id: 5,
        name : "FRANCESCANA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-5a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 1,
        price : 25
    },
    {
        id: 6,
        name : "CAMPAGNOLA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-6a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 4,
        price : 95
    },
    {
        id: 7,
        name : "BOSCAIOLA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h4-product-7a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 3,
        price : 85
    },
    {
        id: 8,
        name : "MARE E MONTI",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h4-product-8a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 3,
        price : 65
    },
    {
        id: 9,
        name : "PARMIGIANA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-1a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 2,
        price : 50
    },
    {
        id: 10,
        name : "RICOTTA E SPINAC",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-2a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 2,
        price : 75
    },
    {
        id: 11,
        name : "MEDITERRANEA",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h3-product-img-3a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 4,
        price : 90
    },
    {
        id: 12,
        name : "PIZZA AL PESTO",
        img : "https://donpeppe.qodeinteractive.com/wp-content/uploads/2019/10/h4-product-12a.png",
        desc : "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients, baked quickly—usually, in a commercial setting, using a wood-fired oven heated to a very high temperature—and served hot.",
        rate : 2,
        price : 45
    }
]